module.exports = __webpack_public_path__ + "static/media/spank.5fc382bc.png";